import { useState } from "react";
import { hexToRgba } from "@/lib/utils";

type ShowMoreButtonProps = {
  onClick: () => void;
  disabled: boolean;
  isLoading: boolean;
  primary: string;
  onPrimary: string;
  primaryInk: string;
  outline: string;
};

export function ShowMoreButton({
  onClick,
  disabled,
  isLoading,
  primary,
  onPrimary,
  primaryInk,
  outline,
}: ShowMoreButtonProps) {
  const [isHovered, setIsHovered] = useState(false);
  const isHoveredOrActive = isHovered && !disabled;

  return (
    <div className="flex items-center justify-center pt-6 pb-24 md:pb-8">
      <button
        onClick={onClick}
        disabled={disabled}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="flex h-[34px] px-6 justify-center items-center rounded-full cursor-pointer text-sm font-semibold leading-[140%] transition-colors border bg-white disabled:opacity-50 disabled:cursor-not-allowed"
        style={
          isHoveredOrActive
            ? {
                backgroundColor: primary,
                color: onPrimary,
                borderColor: "transparent",
              }
            : {
                borderColor: hexToRgba(outline, 0.6),
                color: primaryInk,
              }
        }
      >
        {isLoading ? "Loading..." : "Show More"}
      </button>
    </div>
  );
}
